import * as React from 'react'

const SvgR2Q5 = (props) => {
  const { color } = props
  return (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 48 48' {...props}>
      <g fill='none' fillRule='evenodd'>
        <path d='M0 0h48v48H0z' />
        <path
          fill={color || '#FFF'}
          fillRule='nonzero'
          d='M34.1 35.489H14v-23.5c0-5.5 4.5-10 10-10 1 0 2 .1 2.9.4l2-1.6 3.1 2-.7 2.3c1.8 1.9 2.8 4.3 2.8 6.9v23.5Zm-18.6-18.7v12.3h2.4v-12.3h-2.4Zm3.7 4.7h10.2v-1.7H19.2v1.7Zm0-3h10.2v-1.7H19.2v1.7Zm4.9-6.5c1.7 0 3-1.4 3-3s-1.4-3-3-3c-1.7 0-3 1.4-3 3s1.3 3 3 3Zm5.7-.2c0-.6-.5-1.1-1.1-1.1-.6 0-1.1.5-1.1 1.1 0 .6.5 1.1 1.1 1.1.6 0 1.1-.5 1.1-1.1Zm-20.3 28.3v-25.7h5.8v25.6l2.2 5.4-1.7 2.1H9l-1.7-2.1 2.2-5.3Zm1.5.4h2.8v-1.4H11v1.4Zm13.1-32.8c.7 0 1.3.6 1.3 1.3 0 .7-.6 1.3-1.3 1.3-.7 0-1.3-.6-1.3-1.3 0-.7.6-1.3 1.3-1.3Zm5.7 32.3H18.3l-2.7-5.7h16.9l-2.7 5.7Zm3 .1v-25.7h5.8v25.6l2.2 5.4-1.7 2.1h-6.8l-1.7-2.1 2.2-5.3Zm1.4.4H37v-1.4h-2.8v1.4Z'
        />
      </g>
    </svg>
  )
}

export default SvgR2Q5
